const PageUrls = {
  HOME: "/",
  LOGIN: "/login",
  GAME_LOBBY: "/lobby",
  OPEN_GAME: "/open-game",
};

export default PageUrls;
